<template>
    <b-card :title="title">
        <b-card-header >   

            <b-row>
                <b-col class="col-md-8">
                    <b-input v-model="filter" type="search" placeholder="Search item type..."></b-input>
                </b-col>

                <b-col >
                    <slot></slot>
                </b-col>

            </b-row>
        </b-card-header>
            <b-card-body>
         

            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows/itemsPerPage) }} Total:
                {{  rows}}
            </p>

            <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
      :current-page="currentPage" :filter="filter">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>

            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>




        </b-card-body>
    </b-card>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'ItemTypes-ListItems',
    props: ['type', 'items', 'title'],
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                'description',
                'tax_rate',
                'uom',
                 'size_uom',
                //'is_asset',
    

                {
                    key: 'is_task',
                    label: 'Is Task',
                    formatter: value => (value ? 'Yes' : 'No'),
                },

                {
                    key: 'is_order_item',
                    label: 'Is Order Item',
                    formatter: value => (value ? 'Yes' : 'No'),
                },

                {
                    key: 'is_discount',
                    label: 'Is Discount',
                    formatter: value => (value ? 'Yes' : 'No'),
                },
            ],
        }
    },

    mounted() {},

    methods: {
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        rows() {
        return this.items.length
        }
        
    },
}
</script>
<style></style>
